import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

const SompoCard = styled(Box)(({ theme }) => ({
    flexShrink: 0,
    textAlign: "center",
    transition: "all 0.2s ease-in-out",
    backgroundColor: "#FFFFFF",
    borderRadius: "7px",
    "&:hover": {
        backgroundColor: "#FFFFFF",
        opacity: "0.7",
        cursor: "pointer",
    },
    [theme.breakpoints.up("md")]: {
        width: "215px",
    },
    [theme.breakpoints.down("md")]: {
        width: "160px",
    },
}));

export default SompoCard;
